import { c as _c } from "react/compiler-runtime";
import { Box, type BoxProps, type SxProps, type Theme } from '@mui/material';
import type { PropsWithChildren, Ref } from 'react';
import { MAXIMUM_COLUMNS_MOBILE, useCreditCardCompareColumnContext } from '../../ColumnContext';
type RatingContainerProps = {
  additionalProps?: BoxProps;
  ratingRef?: Ref<HTMLDivElement>;
};
export function RatingContainer(t0) {
  const $ = _c(20);
  const {
    children,
    ratingRef,
    additionalProps
  } = t0;
  const {
    index
  } = useCreditCardCompareColumnContext();
  let additionalSxProps;
  let restAdditionalProps;
  if ($[0] !== additionalProps) {
    if (additionalProps) {
      const {
        sx,
        ...rest
      } = additionalProps;
      additionalSxProps = sx;
      restAdditionalProps = rest;
    }
    $[0] = additionalProps;
    $[1] = additionalSxProps;
    $[2] = restAdditionalProps;
  } else {
    additionalSxProps = $[1];
    restAdditionalProps = $[2];
  }
  const t1 = index > MAXIMUM_COLUMNS_MOBILE - 1 ? "none" : "flex";
  let t2;
  if ($[3] !== t1) {
    t2 = {
      md: "flex",
      xs: t1
    };
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      xs: "column",
      sm: "row"
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      sm: 2
    };
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t2) {
    t5 = {
      display: t2,
      alignItems: "center",
      justifyContent: "center",
      flexDirection: t3,
      flexWrap: "wrap",
      columnGap: t4,
      px: 3,
      pb: 3
    };
    $[7] = t2;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== additionalSxProps || $[10] !== index) {
    t6 = theme => ({
      borderLeft: index !== 0 ? `1px solid ${theme.palette.neutral.lighter}` : 0,
      ...(additionalSxProps && {
        additionalSxProps
      })
    });
    $[9] = additionalSxProps;
    $[10] = index;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t5 || $[13] !== t6) {
    t7 = [t5, t6];
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== children || $[16] !== ratingRef || $[17] !== restAdditionalProps || $[18] !== t7) {
    t8 = <Box ref={ratingRef} {...restAdditionalProps} sx={t7}>{children}</Box>;
    $[15] = children;
    $[16] = ratingRef;
    $[17] = restAdditionalProps;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
}